import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    accessorials: null,
    checkAccessorial: 0
  },
  getters: {
    showAccessorials(state) {
      return state.accessorials;
    }
  },
  mutations: {
    setAccessorials(state, newAccessorials) {
      state.accessorials = newAccessorials;
    },
    checkAccessorial(state) {
      state.checkAccessorial += 1;
    }
  },
  actions: {
    async getAccessorials({ commit }, mode_name) {
      try {
        let params = {};
        params.mode = mode_name;
        const response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/mode/accessorials`,
          {
            params: params,
            ...api.getToken()
          }
        );
        if (response.status === 200) {
          commit("setAccessorials", response.data.data);
        }
      } catch (err) {
        if (err.response.status === 403) return tokenExpired();
        else if (err.response.status === 400) return err.response.status;
        else if (err.response.status !== 200) return errorMessage();
        return err.response;
      }
    },

    async checkAccessorial({ commit }, info) {
      try {
        const actualMode = info.params;
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/accessorial-haul/mode?mode=${actualMode}`,
          info.body,
          api.getToken()
        );
        if (response.status === 201) {
          commit("checkAccessorial");
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async uncheckAccessorial({ commit }, info) {
      try {
        let response = await axios.delete(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/accessorial-haul/${info.body.haul_}/${info.body.accessorial_}/`,
          api.getToken()
        );
        if (response.status === 204) {
          commit("checkAccessorial");
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
